  
<template>


  <div class="container-fluid">

    <div class="row">
      <div class="col-md-10 mx-auto">
        <h1>
          <font-awesome-icon icon="home" /> Home - <a href="#">My Profile</a>
          <div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>

<b-modal id="modal-lg" size="lg" title="Profile">
<div class="panal2">
    <div>
      
      <div class="panal-header2"> {{ info.PageName }}</div>
     <div class="panal-body2">

  <div v-html="info.PageDescription"></div>
      </div>
     </div>

  

  </div>





  </b-modal>

</div>
          
          
          
          </h1>
      </div>
      <div class="col-md-10 mx-auto">
        <div class="panal mt-20">
          <div class="panal-header">Profile </div>
          <div class="panal-body">
<div class="row">
  <div class="col-md-9">
   <div class="row">

 <div class="col-md-3 col-sm-12">
                    <div class="profileData">Student Name </div>
                  </div>
                  <div class="col-md-9 col-sm-12">
                    <div class="profileData2">
                   {{ApplicantDataList.FirstNameEN}}
                    {{ApplicantDataList.SecondNameEN}} {{ApplicantDataList.ThirdNameEN}}
                    {{ApplicantDataList.LastNameEN}} {{ApplicantDataList.FamilyNameEN}}
                    </div>
                  </div>


 <div class="col-md-3 col-sm-12">
                    <div class="profileData">Applicant Code</div>
                  </div>
                  <div class="col-md-9 col-sm-12">
                    <div class="profileData2">
                     {{ApplicantDataList.Username}}
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-12">
                    <div class="profileData">National Id </div>
                  </div>
                  <div class="col-md-9 col-sm-12">
                    <div class="profileData2">
                   {{ApplicantDataList.NationID}}
                    </div>
                  </div>

                   <div class="col-md-3 col-sm-12">
                    <div class="profileData">Email </div>
                  </div>
                  <div class="col-md-9 col-sm-12">
                    <div class="profileData2">
                   {{ApplicantDataList.UserEmail}}
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-12">
                    <div class="profileData">Nationalty </div>
                  </div>
                  <div class="col-md-9 col-sm-12">
                    <div class="profileData2">
                   {{ApplicantDataList.NationalityNameEN}}
                    </div>
                  </div>


            
            
              
            
            </div>

  </div>
  <div class="col-md-3">

   <div class="app-stu-photo">
              <div class="photo">
                <div class="image-preview" v-if="newImage">
                  <img class="preview" :src="newImage">
                </div>
                <div class="image-preview" v-else>
                  <img class="preview" :src="currenUser.ProfileImgUrl">
                </div>

              </div>
              <div>
                <div class="file-upload-form mt-2 ">
                  Upload an image file:

                  <input type="file" @change="previewImage" accept="image/*" ref="file" v-on:change="handleFileUpload()">
                   <progress max="100" :value.prop="uploadPercentage" :hidden="!submitted"></progress>
                </div>
              <button class="btn btn-primary btn-sm m-auto btn-block" @click="submitFile">  Upload  <b-icon-upload></b-icon-upload></button>
              </div>


            </div>

  </div>
  </div>


         
         
            <div class="clearfix"></div>
               <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

          </div>
        </div>
      </div>



    </div>
  </div>




</template>

<script>
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services'
import Axios from 'axios'
import { API_URL } from '../../services/API_URL'
import ApplicantService from '../../services/Applicant/Applicant.service'
  export default {
    data() {
      return {
         info: '',
        imageData: "",
        newImage: "",
        file: '',
        uploadPercentage: 0 ,
        ApplicantDataList: [],
        submitted: false,
        message:'',
        successful:false,
      }
    },
    computed: {
      currenUser() {
        return this.$store.state.auth.user
      },
    },
    mounted() {
      let id = 6;
 ApplicantService.GetHelpPages(id).then(response => {
        this.info = response.data
      });

      ApplicantDataServices.GetAllApplicantDataList(this.currenUser.UserIDSerial).then(Response => {
        this.ApplicantDataList = Response.data;
      
      }, error => {
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
        if (error.response.status == 404) this.message = ''
      });
    },
    methods: {
      handleFileUpload(){
 this.file = this.$refs.file.files[0];
},
      previewImage: function (event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
          // create a new FileReader to read this image and convert to base64 format
          var reader = new FileReader();
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
            // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
            // Read image as base64 and set to imageData
           // this.imageData = e.target.result;
            this.newImage = e.target.result
          }
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0]);
        }
      },
      submitFile(){
  this.submitted =true
  /*
    Initialize the form data
  */
  let formData = new FormData();
  /*
    Add the form data we need to submit
  */
  formData.append('UploadedFile', this.file);
  formData.append('ApplicantID', this.currenUser.UserIDSerial)
 
 
  Axios.post( API_URL + '/ApplicantData/PostUpdateApplicantProfilePicture',
    formData,
    {
      headers: {
          'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: function( progressEvent ) {
        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
      }.bind(this)
    }
  ).then(error=>{
    this.submitted =false
    this.uploadPercentage = 0 
/*eslint-disable-next-line*/
    console.log('SUCCESS!!',error);
    
              this.successful =true
              this.message = "Image Updated Saved Successfully "
              this.$store.state.auth.user.ProfileImgUrl = error.data 
                
  })
  .catch(error =>{
                /*eslint-disable-next-line*/
           console.log('FAILURE!!',error.response.data.Message);
           
              this.successful =false
              this.submitted =false
              this.uploadPercentage = 0 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.Message ||
                error.toString();
            
  });
},
    }
  }
</script>


<style scoped>
  .file-upload-form,
  .image-preview {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 20px;
  }
  .photo {
    /* background-image: url(../assets/images.png); */
    background-repeat: no-repeat;
    background-size: cover;
    height: 200px;
    padding: 0px 0px 0px 0px;
  }
  img.preview {
    width: 200px;
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
    height:160px;
  }
  table tr th {
    background-color: #4caf5000 !important;
    color: #333;
    font-weight: bold;
  }
  .panal {
    background: #fff;
    border-radius: 10px;
    color: #fff;
    padding: 0px 0px 20px 0px;
    margin: 10px 0;
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  }
  .panal-header {
    color: #333;
    font-weight: bold;
  }
  .panal {
    background: #fff;
    border-radius: 10px;
    color: #fff;
    padding: 0px 0px 20px 0px;
    margin: 10px 0;
    margin-bottom: 20px !important;
  }
  .panal-header {
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
    width: 50%;
    /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
  }
  .table .thead-light th {
    color: #495057;
    background-color: #e9ecef !important;
    border-color: #dee2e6 !important;
    font-size: 13px;
  }
  .panal-body {
    padding: 20px;
    color: #333;
  }
  .app-stu-photo {
    float: right;
    width: 240px;
    border-radius: 10px;
    border: 1px solid #111;
 
  }
  .app-stu-photo img {
    width: 100%;
    border-radius: 10px;
    /* background-image: url(../assets/images.png); */
  }
  .app-All {
    width: 60%;
    float: left;
  }
  .app-stu {
    border-bottom: 1px #333 dotted;
    padding: 10px 0px;
  }
  .app-stu .title {
    font-weight: bold;
  }
  .app-stu .title span {
    font-weight: 100;
  }
  h1 {
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
  }
  h1 a {
    color: #50BD77;
  }
  input[type="file"] {
    /* border: 1px solid #ccc; */
    display: inline-block;
    /* padding: 6px 12px; */
    cursor: pointer;
  }

  .panal2{
  background:#eee;
  border-radius:10px;
color:#333;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header2{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2{
    padding:20px;
    color:#333;
}

.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}

.profileData,
.profileData2 {
  border: 1px dotted #646464;
  padding: 3px 10px;
  font-weight: 700;
  margin: 5px 0px;
}
.profileData {
  color: #285475;
}
.profileData2 {
  color: #ff8600;
}

@media only screen and (max-width: 600px) {
  .panal-header {
    width: 90% !important;
  }
  .app-stu-photo {
    float: none !important;
    margin-top: 20px;
  }
}
</style>
